/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

export interface BadgeProps {
  label: string;
  color: string;
}

export const TemplateBadge: BadgeProps = { label: "Template", color: "#569cd6" };
export const FeaturedBadge: BadgeProps = { label: "Featured", color: "#53A21A" };
export const OfficialBadge: BadgeProps = { label: "Official", color: "#53A21A" };
